import axiosInstance from '../lib/axios';
import type {
  FavoritesEnvelope,
  LatestFilesEnvelope,
} from '../types/favorites.types';

export const favoritesService = {
  async getFavorites(
    params: { page?: number; limit?: number; search?: string } = {}
  ) {
    const res = await axiosInstance.get<FavoritesEnvelope>('/favorites', {
      params,
    });
    return res.data;
  },

  removeFavorite: (documentId: number) =>
    axiosInstance.delete(`/documents/${documentId}/favorite`),

  async getLatestFiles(params: { page?: number; limit?: number } = {}) {
    const res = await axiosInstance.get<LatestFilesEnvelope>('/latest-files', {
      params,
    });
    return res.data;
  },
};

export default favoritesService;

